import { FormControl, FormItem, FormLabel } from "@/src/components/ui/form";
import { Slider } from "@/src/components/ui/slider";
import { SliderLength } from "@/src/components/ui/slider-length";
import { useFormContext } from "react-hook-form";
import { APIFilters } from "../YachtsListing";

export const YachtDetails = (filters: APIFilters) => {
  const { setValue, watch } = useFormContext();
  const cabinsMin = watch("cabinsMin");
  const cabinsMax = watch("cabinsMax");
  const bathroomsMin = watch("bathroomsMin");
  const bathroomsMax = watch("bathroomsMax");
  const yearMin = watch("yearMin");
  const yearMax = watch("yearMax");
  const crewMin = watch("crewMin");
  const crewMax = watch("crewMax");
  const ratingMin = watch("ratingMin");
  const ratingMax = watch("ratingMax");
  const lengthMin = watch("lengthMin");
  const lengthMax = watch("lengthMax");
  return (
    <div className="flex flex-col pb-3">
      <h3 className="text-lg font-semibold col-span-full mb-3">Cabins, Bathrooms, Year, Crew, Rating, Length</h3>
      <div className="flex flex-col gap-x-6 align-center w-full gap-y-4">
        <FormItem className="w-full">
          <FormLabel className="flex text-base leading-6 font-normal mb-4">Cabins</FormLabel>
          <FormControl>
            <Slider
              thumbs={[cabinsMin, cabinsMax]}
              value={[cabinsMin, cabinsMax]}
              min={filters.cabinsMin}
              max={filters.cabinsMax}
              step={1}
              onValueChange={(value) => {
                setValue("cabinsMin", value[0], { shouldDirty: true });
                setValue("cabinsMax", value[1], { shouldDirty: true });
              }}
            />
          </FormControl>
        </FormItem>
        <FormItem className="w-full">
          <FormLabel className="flex text-base leading-6 font-normal mb-4">Bathrooms</FormLabel>
          <FormControl>
            <Slider
              thumbs={[bathroomsMin, bathroomsMax]}
              value={[bathroomsMin, bathroomsMax]}
              min={filters.bathroomsMin}
              max={filters.bathroomsMax}
              step={1}
              onValueChange={(value) => {
                setValue("bathroomsMin", value[0], { shouldDirty: true });
                setValue("bathroomsMax", value[1], { shouldDirty: true });
              }}
            />
          </FormControl>
        </FormItem>
        <FormItem className="w-full">
          <FormLabel className="flex text-base leading-6 font-normal mb-4">Year</FormLabel>
          <FormControl>
            <Slider
              thumbs={[yearMin, yearMax]}
              value={[yearMin, yearMax]}
              min={filters.yearMin}
              max={filters.yearMax}
              step={1}
              onValueChange={(value) => {
                setValue("yearMin", value[0], { shouldDirty: true });
                setValue("yearMax", value[1], { shouldDirty: true });
              }}
            />
          </FormControl>
        </FormItem>
        <FormItem className="w-full">
          <FormLabel className="flex text-base leading-6 font-normal mb-4">Crew members number</FormLabel>
          <FormControl>
            <Slider
              thumbs={[crewMin, crewMax]}
              value={[crewMin, crewMax]}
              min={filters.crewMin}
              max={filters.crewMax}
              step={1}
              onValueChange={(value) => {
                setValue("crewMin", value[0], { shouldDirty: true });
                setValue("crewMax", value[1], { shouldDirty: true });
              }}
            />
          </FormControl>
        </FormItem>
        <FormItem className="w-full">
          <FormLabel className="flex text-base leading-6 font-normal mb-4">Supplier ranking</FormLabel>
          <FormControl>
            <Slider
              thumbs={[ratingMin, ratingMax]}
              value={[ratingMin, ratingMax]}
              min={filters.ratingMin}
              max={filters.ratingMax}
              step={1}
              onValueChange={(value) => {
                setValue("ratingMin", value[0], { shouldDirty: true });
                setValue("ratingMax", value[1], { shouldDirty: true });
              }}
            />
          </FormControl>
        </FormItem>
        <FormItem className="w-full">
          <FormLabel className="flex text-base leading-6 font-normal mb-4">Length</FormLabel>
          <FormControl>
            <SliderLength
              thumbs={[lengthMin, lengthMax]}
              value={[lengthMin, lengthMax]}
              min={filters.lengthMin}
              max={filters.lengthMax}
              step={1}
              onValueChange={(value) => {
                setValue("lengthMin", value[0], { shouldDirty: true });
                setValue("lengthMax", value[1], { shouldDirty: true });
              }}
            />
          </FormControl>
        </FormItem>
      </div>
    </div>
  );
};
